import React, { useContext } from 'react';
import { Box, SxProps, Theme, Divider } from '@mui/material';
import { BrandingContext } from '../../contexts/BrandingContext';

function AuthHeroImage() {
  const brandingContext = useContext(BrandingContext);
  const heroImage = brandingContext?.heroImage;
  
  if (!heroImage) {
    return null;
  }
  
  const imageStyles: SxProps<Theme> = {
    width: '100%',
    height: 'auto',
    borderRadius: 2,
    mb: 3,
    display: 'block',
    maxHeight: 160,
    objectFit: 'contain',
    mx: 'auto'
  };
  
  return (
    <Box sx={{ textAlign: 'center' }}>
      <img 
        src={heroImage} 
        alt="Authentication Hero" 
        style={imageStyles as React.CSSProperties} 
      />
      <Divider sx={{ mt: 3 }} />
    </Box>
  );
}

export default AuthHeroImage;
